/**
 * Case document "Visibility" UI = whether the **client can view** the file.
 * API `biz_view_only` is the inverse: true = business-only (hidden from client).
 */

/** Default UI switch: client can view. */
export const DEFAULT_CLIENT_CAN_VIEW = true;

export function flipBoolean(current: boolean): boolean {
  return !current;
}

/** UI "client can view" → API `biz_view_only`. */
export function clientVisibilityToBizViewOnly(clientCanView: boolean): boolean {
  return !clientCanView;
}

/** API `biz_view_only` → UI switch checked (client can view). */
export function bizViewOnlyToClientVisibility(apiBizViewOnly: boolean): boolean {
  return !apiBizViewOnly;
}
